export const validateEmailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const supportEmail = "support@splitcart.com"
export const supportNumber = "888 625-4349"

/**
 * @description Default percentage used to calculate the additional fee transaction on a Pledge.
 * @format Float between 0-1
 */
export const defaultFeePercent = 0.04

/** @description Go equivalent of 0 */
export const emptyDate = "0001-01-01T00:00:00Z"

/**
 * @description Pledge amount maximum
 * @format Number in Pennies
 */
export const max = 400000
/**
 * @description Goal amount maximum
 * @format Number in Pennies
 */
export const groupMax = 9999999
export const min = 100

export const links = {
    // appStore: 'https://apps.apple.com/us/app/splitcart/id1530432928',
    // facebook: 'https://www.facebook.com/Splitcart/',
    // instagram: 'https://www.instagram.com/splitcart_/',
    // twitter: 'https://twitter.com/splitcart_/',
    privacyPolicy: 'https://splitcard.com/privacy-policy/',
    termsOfUse: 'https://splitcard.com/terms-and-conditions/',
    // patents: 'https://splitcart.com/patents/',
    FAQs: 'https://splitcard.com/faq-and-support/',
    // apiDocumentation: 'https://splitcart.readme.io/docs',
    contactUs: 'https://splitcard.com/faq-and-support/',
    applePay: 'https://support.apple.com/en-us/108398#:~:text=How%20to%20add%20a%20debit%20or%20credit%20card%20for%20Apple,Settings%20%3E%20Wallet%20%26%20Apple%20Pay.',
    googlePay: 'https://support.google.com/wallet/answer/12058983?hl=en'
}

export const sessionStorageKeys = {
    INITIAL_PATH: "INITIAL_PATH",
    SPLITCART_TITLE: "SPLITCART_TITLE",
    SPLITCART_DESCRIPTION: "SPLITCART_DESCRIPTION"
}

export const localStorageKeys = {
    "vc-stored-group-ids": "vc-stored-group-ids",
}

export const loaderTextEvents = {
    default: 'loading\u2026',
    splitcartCreation: ['Creating your Splitcart', 'Generating Link', 'Almost There'],
    paymentProcessing: ['Processing Payment', 'Verifying', 'Almost Ready'],
    splitcartLoading: ['Fetching Details', 'Loading Splitcart', 'Almost Ready'],
}
